import { FieldValues } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import { patchContentPage, postContentPage } from 'api/createContent';
import { useSaveErrorHandler } from 'components/Pages/Admin/PageTypes/shared/hooks/useSaveErrorHandler';
import { TTripEvent } from 'detailsv2/structure';
import { showErrorSnackbar } from 'hooks/useSnackbar';
import { pageDataSelector } from 'store/page/selectors';
import { publishPageThunk, savePageThunk } from 'store/page/thunks';
import { createOptionFromPageV2 } from 'utils/createOptionFromPage';
import { removeAIBlocksFromProposal } from 'utils/itineraries/functions/builderUtils';
import { EMixpanelEvents, trackEvent } from 'utils/mixpanel';

import { TWizardReturn } from '../../../AccomodationModal/hooks';
import { IContentPage } from '../types';

type CommonWizardData = {
  default: TTripEvent | any;
  details?: IContentPage;
  page?: IContentPage;
} & Record<any, any>;

type Props = {
  initialValues?: Record<string, any>;
  wizard: TWizardReturn<CommonWizardData>;
};

function useContentSubmitHandlers({ initialValues = {}, wizard }: Props) {
  const dispatch = useDispatch();
  const errorHandler = useSaveErrorHandler();

  const handleDetailsSubmit = async (formValues: FieldValues & { id?: string | number }) => {
    const pageId = formValues?.id;

    try {
      let resp = {};
      resp = await postContentPage(formValues, 'details');
      trackEvent(EMixpanelEvents.CREATE_PAGE, formValues);
      /**
       * This code is needed to update attachedPage
       * So far there is no request for such functionality, so the code below is commented out
       */
      // if (!pageId) {
      // } else {
      //   resp = await patchContentPage(pageId, formValues, 'details');
      // }

      wizard.updateData('page', resp);
      wizard.updateData('details', resp);
      wizard.goToStep('page');
    } catch (e) {
      errorHandler(e);
    }
  };

  const page = useSelector(pageDataSelector);

  const handlePageSubmit = async () => {
    try {
      const landing = removeAIBlocksFromProposal(page?.landing);
      const landingPage = landing?.pages?.[0];
      await dispatch(savePageThunk({ ...landingPage, current_step: 'page' }));
      await dispatch(publishPageThunk());
      const attachedPage = createOptionFromPageV2(page);
      wizard.updateData('default', {
        ...initialValues,
        attachedPages: [{ ...attachedPage, id: attachedPage.id.toString() }],
      });
      wizard.goToStep('default');
    } catch (e) {
      const err = e as Error;
      const defaultErrorMessage = 'Failed to save the page';
      showErrorSnackbar(err?.message || defaultErrorMessage);
      console.error(e);
    }
  };
  return { handleDetailsSubmit, handlePageSubmit };
}

export { useContentSubmitHandlers };
